import React from "react";
import online from "../Images/About/online.png";
import chat from "../Images/About/chat.png";

const AboutUs = () => {
  return (
    <div className="mx-4 mx-md-5 px-md-5 mt-3">
      <h2 className="text-center mb-3">About Us</h2>
      <div>
        <p className="fs-5 lh-lg" style={{ fontFamily: "sans-serif" }}>
          Welcome to Medical Hall, a trusted name in the medical industry
          for over 25 years. We are a family-owned business dedicated to
          providing quality medical products and services to our customers. Our
          mission is to improve the health and well-being of our community by
          offering a comprehensive range of medical supplies and equipment. At
          Medical Hall, we believe in putting our customers first. Our
          knowledgeable and friendly staff is committed to helping you find the
          products and services that best meet your needs. We take pride in our
          personalized service and strive to build lasting relationships with
          our customers.
        </p>
      </div>

      <div className="mx-md-5 mt-5 d-flex flex-column align-items-center">
        <h2 className="text-center">Our Future Plans</h2>
        <div className="row row-cols-1 row-cols-md-2 align-items-center w-75">
          <div style={{ height: 20 + "rem" }}>
            <img src={online} alt="online" className="w-100 h-100" />
          </div>
          <div>
            <h4 className="mb-4">Online Consultation</h4>
            <p>
              We plan to integrate an online consultation system on our website,
              where patients can connect with our certified healthcare
              professionals from the comfort of their own homes.
            </p>
          </div>
        </div>
        <div className="row row-cols-md-2 row-cols-1 flex-row-reverse align-items-center w-75">
          <div style={{ height: 20 + "rem" }}>
            <img src={chat} alt="chat" className="w-100 h-100" />
          </div>
          <div>
            <h4 className="mb-4">Chat System</h4>
            <p>
              We plan to implement a chat system that allows patients to get
              real-time answers to their questions. Our team will be available
              to provide support and assistance 24/7 through this platform.
            </p>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default AboutUs;
